import { render, staticRenderFns } from "./ResetPage.vue?vue&type=template&id=0754899e&scoped=true"
import script from "./ResetPage.vue?vue&type=script&lang=js"
export * from "./ResetPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/reset.css?vue&type=style&index=0&id=0754899e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0754899e",
  null
  
)

export default component.exports